import React, { useCallback, useEffect, useRef, useState } from 'react'
import StartServiceCardsContainer from './StartServiceCardsContainer'
import { useDispatch, useSelector } from 'react-redux'
import ChatMessage from './ChatMessage';
import CoversationProgressbar from './CoversationProgressbar';
import { useParams } from 'react-router-dom';
import Sticky from 'react-stickynode';
import FopQueriesFilter from '../atoms/FopQueriesFilter';

const ChatConversation = (props: any) => {
    const params = useParams();
    const dispatch = useDispatch();
    const { access } = useSelector((state: any) => state.user);
    const [conversations, setConversations] = useState<any>(null);
    const bottomRef: any = useRef(null);
    let selectConversations = useSelector((state: any) => state.conversations);
    useEffect(() => {
        let cnv = props.conversations ?? selectConversations.conversations;
        setConversations(cnv)
    }, [selectConversations, props.conversations])

    useEffect(() => {
        bottomRef?.current?.scrollIntoView(false);
    }, [conversations])
    const renderConversations = useCallback(() => {
        if (conversations === null) {
            return <StartServiceCardsContainer />
        }
        return (
            <div ref={bottomRef}>
                {conversations.map((conversation: any, index: number) => {
                    return (<ChatMessage
                        key={index}
                        {...conversation}
                        enabledToAnswer={(conversations.length - 1) === index && access.write === true} />)
                })}
                <CoversationProgressbar />
            </div>
        )
    }, [conversations])

    const handleCategoryChange = (category: string) => {
        dispatch({
            type: "CATEGOTY_CHANGE",
            payload: category
        })
    }

    const renderConversationCategoryType = useCallback(() => {
        if (conversations === null || params.chatId === undefined) {
            return <></>
        }
        const { conversationCategory } = selectConversations;
        return (
            <div className="conversation-category-type" style={{ zIndex: 1, position: "relative" }}>
                <Sticky enabled={true} top={55} bottomBoundary={"#app-footer"}>
                    <div className="flex justify-center box-container bg-[#1a1a24] items-center">
                        <div className="border border-[#8c8c8c59] rounded-sm flex gap-3 p-2 mt-2">
                            <span
                                onClick={() => handleCategoryChange("EngagementSpecific")}
                                className={`p-2 cursor-pointer ${conversationCategory === "EngagementSpecific" && "!bg-[#8c8c8c59]"} flex items-center justify-center`}>
                                Engagement specific
                            </span>
                            <span
                                onClick={() => handleCategoryChange("Generic")}
                                className={`p-2 cursor-pointer ${conversationCategory === "Generic" && "!bg-[#8c8c8c59]"} flex items-center justify-center`}>
                                Generic/FoP queries
                            </span>
                        </div>
                        {conversationCategory === "Generic" && (
                            <div className="absolute right-[1rem] min-w-40">
                                <FopQueriesFilter />
                            </div>
                        )}
                    </div>
                </Sticky>
            </div>
        )
    }, [conversations, selectConversations])

    return (
        <>
            {renderConversationCategoryType()}
            <div className="px-5 py-5 !h-[83vh] !overflow-y-scroll flex flex-col-reverse">
                
                {renderConversations()}
            </div>
        </>
    )
}

export default ChatConversation